import getApiClient from '@/plugins/api-client'
import { format } from 'date-fns'

export default {
    loadCharts: function () {
        const self = this,
            api = getApiClient(self.$store),
            parameters = {}

        self.filters['createdAt[before]'] = self.filters['month[before]']
        self.filters['createdAt[after]'] = self.filters['month[after]']
        Object.keys(self.filters).forEach(filter => {
            if (self.filters[filter]) {
                parameters[filter] = self.filters[filter]
            }
        })

        if(parameters['month[after]']){
            parameters['month[after]'] += ' 00:00:00'
            parameters['createdAt[after]'] += ' 00:00:00'
        }

        if(parameters['month[before]']) {
            parameters['month[before]'] += ' 23:59:59'
            parameters['createdAt[before]'] += ' 23:59:59'
        }

        api.get('/professional_categories', {
            params: parameters
        })
            .then(result => {
                self.mountChart(result.data['hydra:member'])

                api.get('/work_profiles', {
                    params: {
                        page: self.currentPage,
                        itemsPerPage: self.itemsPerPage,
                        'order[createdAt]': self['order[createdAt]'],
                        ... parameters
                    }
                })
                    .then(workProfilesResult => {
                        self.totalPages = Math.ceil(workProfilesResult.data['hydra:totalItems'] / self.itemsPerPage)
                        self.profiles = workProfilesResult.data['hydra:member']
                    })
            })
            .catch(error => {
                console.log(error)
            })
    },

    mountChart: function (data) {
        const self = this
        let categories = ['bars_restaurants', 'casting', 'event_support', 'master_of_ceremonies']

        categories.forEach(category => {
            self.charts[category]['total'] = 0
            self.charts[category]['months'] = {}

            data.filter(item => {
                return item.category === category
            }).forEach(filteredItem => {
                let month = format(new Date(filteredItem.month), 'MMM-yyyy')
                self.charts[category]['months'][month] = filteredItem.total
                self.charts[category]['total'] += filteredItem.total
            })
        })
    },

    setCategory(category) {
        this.filters.category = category.code
    },

    clearFilters() {
        this.filters.category = null
        this.filters['month[after]'] = null
        this.filters['month[before]'] = null

        this.loadCharts()
    },

    updatePage: function(page) {
        this.currentPage = page
    }
}
